import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as homeActions from '../../../redux/homeActions';
import { bindActionCreators } from 'redux';
import * as Constants from '../../../utilities/constants/Constants';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import * as threeDViewActions from '../../../redux/threeDViewActions';
import * as wallHandler from '../../../redux/actions/wallHandler';
import './ThreeDComponent.scss';
import { renderProject } from '../../../utilities/ProjectCanvasRenderer/ProjectCanvasRenderer';
import combinedStore from '../../../CombinedStore';
import { isTransparentModel } from '../../../utilities/HelperFunctions/HelperFunctions';
import CustomModal from '../../../UI/CustomModal/CustomModal';
import TemplateSelectionDialogueIn3D from '../../../components/TemplateSelectionDialogues/TemplateSelectionDialogueIn3D';

window.threeDViewerLoaded = () => {
  const { selectedProduct } = combinedStore.getState().home;
  const { materials } = combinedStore.getState().modal.storeData;
  const finish = materials[0].finishing;
  selectedProduct.activeProductSize.templates.forEach(template => {
    const frame = document.getElementById('iFrame');
    const window = frame.contentWindow;
    if (window) {
      window.setMaterial(
        selectedProduct.activeProductSize.instance,
        template.material,
        combinedStore.dispatch(
          threeDViewActions.specularValueForFinish(
            finish,
            template,
            template.identifier
          )
        )
      );
      combinedStore.dispatch(fabricCanvasActions.setIsThreeDViewLoaded(true));
    }
  });
};

class ThreeDComponent extends Component {
  componentDidUpdate(prevProps) {
    const { materialIndex } = this.props;

    if (prevProps.materialIndex != materialIndex) {
      this.applyMaterialType();
    }
  }

  componentWillUnmount() {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.setIsThreeDViewLoaded(false);
  }

  frameLoaded = () => {
    const { dispatchers, selectedProduct, is3DViewLoaded } = this.props;
    dispatchers.fabricCanvasActions.setInitialLoader(false);
    const frame = document.getElementById('iFrame');
    if (frame) {
      const frameWindow = frame.contentWindow;
      let url = selectedProduct.threeDPreviewUrl;
      if (selectedProduct.host === Constants.THREE_JS) {
        url = 'https://duoktjsn1iojm.cloudfront.net/Three_JS_3D/';
      }
      if (frameWindow && !is3DViewLoaded) {
        const {
          sku,
          category,
          timestamp,
          alIntensity,
          dlIntensity,
          flIntensity,
          camPosX,
          camPosY,
          camPosZ,
          rotatable,
          activeProductSize
        } = selectedProduct;

        const { instance } = activeProductSize;

        const productProperties = {
          sku,
          category,
          timestamp,
          instance,
          alIntensity,
          dlIntensity,
          flIntensity,
          camPosX,
          camPosY,
          camPosZ,
          rotatable,
          transparentModel: isTransparentModel(selectedProduct.groupType)
        };
        frameWindow.load3DEditorWithURL(url, productProperties);
      }
    }
  };

  getValidMaterialFinish = () => {
    const { storeData, materialIndex } = this.props;
    const { materials } = storeData;
    for (let i = 0; i < materials.length; i++) {
      if (i == materialIndex) {
        return materials[i].finishing;
      }
    }
    return '';
  };

  applyMaterialType = () => {
    const { dispatchers } = this.props;
    const frame = document.getElementById('iFrame');
    const frameWindow = frame.contentWindow;
    if (frame) {
      const { selectedProduct } = this.props;
      selectedProduct.activeProductSize.templates.forEach(template => {
        const finish = this.getValidMaterialFinish();
        frameWindow.setMaterial(
          selectedProduct.activeProductSize.instance,
          template.material,
          dispatchers.threeDViewActions.specularValueForFinish(
            finish,
            template,
            template.id
          )
        );
      });
    }
  };

  checkFor3DRenderHost = host => {
    switch (host) {
      case Constants.CL3VER_HOST:
        return `${Constants.APP_PUBLIC_PATH}/Resources/3DRender/ThreeD.html`;
      case Constants.SKETCH_FAB:
        return `${Constants.APP_PUBLIC_PATH}/Resources/3DRender/ThreeDSketchfab.html`;
      case Constants.THREE_JS:
        return `${Constants.APP_PUBLIC_PATH}/Resources/3DRender/threeDRender.html`;
      default:
        return `${Constants.APP_PUBLIC_PATH}/Resources/3DRender/ThreeDCGI.html`;
    }
  };

  templateSelectionApplied = index => {
    const { dispatchers } = this.props;
    dispatchers.wallHandler.templateSelectionApplied(index);
  };

  templateSelectionCancelled = () => {
    const { dispatchers } = this.props;
    dispatchers.wallHandler.showOrHideTemplateSelectionDialogue(false, null);
  };

  render() {
    const {
      selectedProduct,
      viewType,
      is3DViewLoaded,
      dispatchers,
      showTemplateSelectionDialogue,
      project
    } = this.props;

    let frameSource = '';
    if (selectedProduct) {
      frameSource = this.checkFor3DRenderHost(selectedProduct.host);
    }

    if (viewType === Constants.THREE_D_TYPE && is3DViewLoaded) {
      const frame = document.getElementById('iFrame');
      if (frame) {
        const frameWindow = frame.contentWindow;
        frameWindow.showProgressIndicator();

        const renderJson = dispatchers.threeDViewActions.renderJSONForWalls(
          project,
          true
        );
        renderProject(renderJson, dataURLs => {
          dataURLs.forEach((dataURL, index) => {
            frameWindow.setPreviewImage(
              selectedProduct.activeProductSize.instance,
              selectedProduct.activeProductSize.templates[index].material,
              dataURL.image_data,
              null
            );
          });
          frameWindow.hideProgressIndicator();
        });
      }
    }

    return (
      <>
        <iframe
          frameBorder='0'
          id='iFrame'
          src={frameSource}
          title='threeD'
          style={{
            width: '100%',
            height: '100%'
            // marginTop: '2%'
          }}
          onLoad={this.frameLoaded}
        />
        {showTemplateSelectionDialogue ? (
          <CustomModal>
            <TemplateSelectionDialogueIn3D
              templates={selectedProduct.activeProductSize.templates}
              cancelHandler={this.templateSelectionCancelled}
              okHandler={templateIndex => {
                const indexInInteger = parseInt(templateIndex, 10);
                this.templateSelectionApplied(indexInInteger);
              }}
            />
          </CustomModal>
        ) : null}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    materialIndex: state.sideBar.materialIndex,
    project: state.finalCheck.project,
    storeData: state.modal.storeData,
    activeObject: state.fabricCanvas.activeObject,
    selectedProduct: state.home.selectedProduct,
    is3DViewLoaded: state.fabricCanvas.is3DViewLoaded,
    viewType: state.fabricCanvas.viewType,
    refresh3D: state.fabricCanvas.refresh3D,
    showTemplateSelectionDialogue:
      state.fabricCanvas.showTemplateSelectionDialogue
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      threeDViewActions: bindActionCreators(threeDViewActions, dispatch),
      wallHandler: bindActionCreators(wallHandler, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThreeDComponent);
